import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_2 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_3 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_4 = {
  key: 0,
  class: "activityMetaLabel"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "activityMetaLabel"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "activityAdditionalInfo" }
const _hoisted_11 = { class: "col-md-1 text-right pr-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", { class: "btn desktop-only" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" })
], -1)
const _hoisted_13 = { class: "btn mobile-only w-100 text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "row activity activity-non-featured",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitSelectedActivity()))
  }, [
    (_ctx.activityDaySchedule.isAllDayEvent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "All Day"))
      : _createCommentVNode("", true),
    (_ctx.activityDaySchedule.toBeDetermined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "TBD"))
      : _createCommentVNode("", true),
    (!_ctx.activityDaySchedule.isAllDayEvent && !_ctx.activityDaySchedule.toBeDetermined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.timeSlot.prependText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.timeSlot.prependText), 1),
                _hoisted_5
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.timeSlot.displayStart) + " ", 1),
          _withDirectives(_createElementVNode("span", null, "— " + _toDisplayString(_ctx.timeSlot.displayEnd), 513), [
            [_vShow, _ctx.timeSlot.displayEnd]
          ]),
          _createTextVNode(),
          (_ctx.timeSlot.appendText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(_toDisplayString(_ctx.timeSlot.appendText), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.calendarContent.displayName), 1),
      _hoisted_9,
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.calendarContent.locationName), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("button", _hoisted_13, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitSelectedActivity()))
        }, _hoisted_15)
      ])
    ])
  ]))
}